var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6ZM6 1C3.25 1 1 3.25 1 6s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5Z",
    fill: "#F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8c-.3 0-.5-.2-.5-.5v-.35c0-.75.4-1.4 1-1.75.4-.2.6-.65.5-1.05-.05-.4-.4-.75-.8-.8-.3-.05-.6 0-.85.2-.2.15-.35.45-.35.75s-.2.5-.5.5-.5-.2-.5-.5c0-.6.25-1.15.7-1.55.45-.4 1.05-.55 1.65-.45.8.15 1.45.8 1.6 1.6.15.85-.25 1.7-1 2.1-.3.15-.45.5-.45.9v.4c0 .3-.2.5-.5.5Z",
    fill: "#F63"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 6,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75c-.4 0-.75-.35-.75-.75s.35-.75.75-.75.75.35.75.75-.35.75-.75.75Zm0-1c-.15 0-.25.1-.25.25s.1.25.25.25.25-.1.25-.25-.1-.25-.25-.25Z",
    fill: "#F63"
  }))));
};
export default SvgQuestion;